import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import ProductImage from "./ProductImage";
export default function ProductCard({ product }) {
  const name = product.display_name || product.displayName || product.name,
    price = product.retail_price ?? product.pricing?.retailPrice;
  return (
    <Link className="product-card" to={`/shop/${product.slug}`}>
      <ProductImage product={product} />
      <div className="product-meta">
        <span>{name}</span>
        <ArrowUpRight size={15} />
      </div>
      <div className="product-card-submeta">
        <span>
          {product.categories?.name || product.category || product.category_id}
        </span>
        {price != null ? (
          <strong>₹{Number(price).toLocaleString("en-IN")}</strong>
        ) : (
          <strong>Enquire</strong>
        )}
      </div>
    </Link>
  );
}